import React, { Fragment } from 'react';

const Tag = ({ isMobile, src, alt, label, className, customClassName }) => (
  <div className={`box-plan-tag ${isMobile ? 'mobile' : 'desktop'} ${className} ${customClassName || ''}`}>
    <img src={src} alt={alt} className="img-cost" />
    <span>{label}</span>
  </div>
);

export const getTag = (plan) => {
  const { covid_coverage, special, travel_renewal } = plan.extra;

  const tags = [
    {
      condition: special && travel_renewal === 'no',
      src: '/assets/images/icons/tags/bestPlan.svg',
      alt: 'melhor custo',
      className: 'tag-best-cost',
      label: 'Melhor custo benefício',
    },
    {
      condition: travel_renewal !== 'no',
      src: '/assets/images/icons/tags/renewal.svg',
      alt: 'ideal para renovação',
      className: 'tag-renewal',
      label: 'Ideal para renovação',
    },
    {
      condition: covid_coverage && !special,
      src: '/assets/images/icons/tags/covid.svg',
      alt: 'cobertura covid',
      className: 'tag-covid',
      label: 'Cobertura Covid',
    },
  ];

  const firstMatchingTag = tags.find((tag) => tag.condition);

  return firstMatchingTag;
};

const Tags = ({ tag, isMobile, customClassName }) => (
  <Fragment>{tag && <Tag isMobile={isMobile} {...tag} customClassName={customClassName} />}</Fragment>
);

export default Tags;



// WEBPACK FOOTER //
// ./src/components/common/Tags/index.jsx